module.exports = __webpack_public_path__ + "img/basicinfo.decb59f8.png";